import React from 'react'
import { Link } from 'react-router-dom'
import './Product.css'

const formatZAR = (amount) =>
  typeof amount === 'number'
    ? new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        minimumFractionDigits: 2,
      }).format(amount)
    : amount

const Product = (props) => {
  const isOutOfStock = props.inStock === false || props.inStock === 0
  const isPreorder = props.isPreOrder === true || props.inStock === 2

  return (
    <Link
      to={`/Product/${props.id}`}
      className={`product group mx-4 flex w-72 shrink-0 flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-md ${
        isOutOfStock ? 'pointer-events-none opacity-60' : ''
      }`}
    >
      <div className="relative aspect-square bg-gradient-to-br from-gray-50 to-gray-100">
        {props.image ? (
          <img
            src={props.image}
            alt={props.name}
            className={`h-full w-full object-scale-up ${isOutOfStock ? 'grayscale' : ''}`}
          />
        ) : (
          <div className="flex h-full flex-col items-center justify-center px-4 text-center">
            <span className="text-sm font-medium text-gray-500">
              No image available
            </span>
          </div>
        )}
        {isOutOfStock && (
          <span className="absolute left-3 top-3 rounded-full bg-gray-600 px-2.5 py-1 text-xs font-semibold text-white">
            Out of stock
          </span>
        )}
        {isPreorder && (
          <span className="absolute left-3 top-3 rounded-full bg-amber-500 px-2.5 py-1 text-xs font-semibold text-white">
            Pre-order
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4 text-left">
        <h2 className={`line-clamp-2 text-base font-semibold ${isOutOfStock ? 'text-gray-500' : 'text-gray-900 group-hover:text-violet-600'}`}>
          {props.name}
        </h2>
        <p className={`mt-auto pt-4 text-lg font-bold ${isOutOfStock ? 'text-gray-400' : 'text-gray-900'}`}>
          {formatZAR(props.price)}
        </p>
      </div>
    </Link>
  )
}

export default Product
